import { Badge } from "@/components/ui/badge";
import { getOrderStatusMeta } from "@/lib/orderStatus";

const AdminStatusBadge = ({ status }) => {
  const meta = getOrderStatusMeta(status);
  return <Badge className={meta.badgeClass}>{meta.label}</Badge>;
};

export default AdminStatusBadge;
